import { Component, OnInit, AfterViewInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { ListItemRendererComponent } from 'gung-list';
import { EdiInvoicesActionConfigService } from '../../../services/edi-invoices-action-config/edi-invoices-action-config.service';
import { EdiNavigationService } from '../../../services/edi/edi-navigation.service';

@Component({
    selector: 'lib-edi-invoice-card-list',
    templateUrl: './edi-invoice-card-list.component.html',
    styleUrls: ['./edi-invoice-card-list.component.css'],
    standalone: false
})
export class EdiInvoiceCardListComponent extends ListItemRendererComponent<any[]> implements OnInit, AfterViewInit {
  protected router = inject(Router);
  public ediNavigationService = inject(EdiNavigationService);

  ediNavigationBaseRoute: string;

  constructor(public actionConfigService: EdiInvoicesActionConfigService) {
    super();
  }

  ngOnInit(): void {
    this.ediNavigationBaseRoute = this.router.url.split('?')[0];
  }

  ngAfterViewInit(): void {
    this.renderFinished?.emit();
  }

  trackByFn(index: any, item: any) {
    return item.id;
  }

  getIds(items: any[]): string[] {
    return items.map(i => i.id);
  }
}
